import { Link as MeridianLink, Text } from '@amzn/meridian';
import { useMemo } from 'react';
import { generateDestinationUrl } from '../utils';

type LinkPreviewProps = {
  marketplace?: string;
  previewUrl: string;
};

export const LinkPreview = ({ marketplace, previewUrl }: LinkPreviewProps) => {
  const fullDestinationUrl = useMemo(() => {
    if (previewUrl && marketplace) {
      return generateDestinationUrl(marketplace, previewUrl);
    }
    return '';
  }, [
    previewUrl,
    marketplace,
  ]);

  return (
    <>
      <Text color="secondary" type="b200">
        Preview of destination URL
      </Text>
      {previewUrl && fullDestinationUrl ? (
        <MeridianLink href={fullDestinationUrl} rel="noreferrer" target="_blank" type="secondary">
          {previewUrl}
        </MeridianLink>
      ) : (
        <Text color="secondary" type="b200">
          Enter a value to see preview URL
        </Text>
      )}
    </>
  );
};
